// js
import { connect } from 'react-redux';
import DefaultLogSizeSelector from '../../components/sources/DefaultLogSizeSelector';
import { updateDSA, fetchDSA } from '../../actions/dsaActions';


const mapStateToProps = state => ({
  dsa: state.dsa,
  value: state.dsa.dsa.defaultLogSizeCoefficient
});

const mapDispatchToProps = dispatch => ({
  onChange: (dsaId, defaultLogSizeCoefficient) => {
    return dispatch(updateDSA(dsaId, { defaultLogSizeCoefficient }))
      .then(() => dispatch(fetchDSA(dsaId)));
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onChange: (defaultLogSizeCoefficient) => (
    dispatchProps.onChange(stateProps.dsa.dsa.id, defaultLogSizeCoefficient)
  )
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DefaultLogSizeSelector);



// WEBPACK FOOTER //
// ./src/containers/sources/DefaultLogSizeSelector.js